"use strict";

export class Localization {
    static _language = null;
    static _localizationList = [];
    static _localizationListAsian = [];
    static _localizationFloatExceptionList = [];

    static get language() {
        return Localization._language;
    }
    static set language(language) {
        Localization._language = language;
    }

    static addLanguage(language,asian) {
        if (typeof language === "string") {
            if (asian) {
                Localization._localizationListAsian.push(language.toLowerCase());
                return;
            }

            Localization._localizationList.push(language.toLowerCase());
            return;
        }
        
        if (!(language instanceof Array)) return;

        if (asian) {
            language.forEach(element => Localization._localizationListAsian.push(element.toLowerCase()));
            return;
        }

        language.forEach(element => Localization._localizationList.push(element.toLowerCase()));
    }
    static removeLanguage(language) {
        if (typeof language === "string") {
            let index;

            if (Localization.isAsianLanguage(language)) {
                index = Localization._localizationListAsian.indexOf(language.toLowerCase());
                if (index == -1) return;
                Localization._localizationListAsian.splice(index, 1);
                return;
            }

            index = Localization._localizationList.indexOf(language.toLowerCase());
            if (index == -1) return;
            Localization._localizationList.splice(index, 1);
            return;
        }

        if (!(language instanceof Array)) return;

        language.forEach(element => {
            let index;

            if (Localization.isAsianLanguage(element)) {
                index = Localization._localizationListAsian.indexOf(element.toLowerCase());
                if (index == -1) return;
                Localization._localizationListAsian.splice(index, 1);
                return;
            }
            
            index = Localization._localizationList.indexOf(element.toLowerCase());
            if (index == -1) return;
            Localization._localizationList.splice(index, 1);
        });
    }
    
    // Returns the requested language if exists,
    // otherwise it returns english as default.
    static validateLocalization(language) {
        if (language === undefined ||
            language == "" ||
            (!Localization._localizationList.includes(language.toLowerCase()) &&
            !Localization._localizationListAsian.includes(language.toLowerCase()))) {
            language = "en";
        }

        Localization._language = language.toLowerCase();
        return Localization._language;
    }

    static isAsianLanguage(language) {
        if (language === undefined) {
            language = Localization._language;
        }
        return Localization._localizationListAsian.includes(language.toLowerCase());
    }

    static addFloatExceptionLanguage(language) {
        Localization._localizationFloatExceptionList.push(language);
    }
    static removeFloatExceptionLanguage(language) {
        const index = Localization._localizationFloatExceptionList.indexOf(language);
        if (index == -1) return;
        Localization._localizationFloatExceptionList.splice(index, 1);
    }

    static validateNumber(number) {
        if (number === undefined) return;
        const index = Localization._localizationFloatExceptionList.indexOf(Localization._language);
        if (index == -1) return number.toString();
        return number.toString().replace(".", ",");
    }
}